import React, { Component } from "react";
import { connect } from "react-redux";
import { Sms, Keyboard, ScreenShare } from "@material-ui/icons";
import { injectIntl } from "react-intl";
import { formatMessage, MainMenuContribution, withModulesManager } from "@openimis/fe-core";

const RIGHT_CLAIMREVIEW = 111008;
const RIGHT_PROCESS = 111011;

class OtpMainMenu extends Component {
    render() {
        const { rights } = this.props;
        let entries = [];

        if (!!rights.filter((r) => r >= RIGHT_CLAIMREVIEW && r <= RIGHT_PROCESS).length) {
            entries.push({
                id: "otp.menu.list",
                text: formatMessage(this.props.intl, "otp", "menu.list"),
                icon: <Sms />,
                route: "/otp/list"
            });
            
        }

        if (!entries.length) return null;
        return (
            <MainMenuContribution
                {...this.props}
                header="OTP"
                icon={<ScreenShare />}
                entries={entries}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
});

export default injectIntl(withModulesManager(connect(mapStateToProps)(OtpMainMenu)));
